import LayoutUtils from '../utils/layout_utils';
import SignupSliderUtils from '../utils/signup_slider_utils';

class Sliders {
  #listingsBasedPricingRules;

  getSliderData(sliderWrapper) {
    const slider = sliderWrapper.querySelector('.js-signup-slider-input');
    const valueInput = sliderWrapper.querySelector('.js-signup-slider-value');
    const min = slider.min;
    const max = slider.max;
    const val = slider.value;
    const percent = ((val - min) / (max - min)) * 100;

    return {slider, valueInput, val, percent};
  }

  updateSlideBackground(slider, percent) {
    slider.style.background = `
      linear-gradient(
        to right,
        #2563eb 0%,
        #2563eb ${percent}%,
        #e5e7eb ${percent}%,
        #e5e7eb 100%
      )
    `;
  }

  updateUnitSlider(sliderWrapper) {
    const {slider, valueInput, val, percent} = this.getSliderData(sliderWrapper);
    this.updateSlideBackground(slider, percent);

    valueInput.value = val;

    const billingPeriod = document.querySelector('.js-signup-period-tabs .active').dataset.period;

    sliderWrapper.closest('.js-plans-description').querySelectorAll('.js-card').forEach((card) => {
      const plan = card.dataset.plan;
      const priceData = SignupSliderUtils.calculateUnitPricing({ units: val, plan, billingPeriod });
      const usdTotalCost = SignupSliderUtils.formatUSD(priceData.monthlyTotal);
      const unitCost = SignupSliderUtils.formatUSD(priceData.perUnit);

      card.querySelector('.js-value').innerText = val;
      card.querySelectorAll('.js-unit-price').forEach((el) => el.innerText = unitCost);
      card.querySelector('.js-total-price').innerText = usdTotalCost;
    });

    document.querySelector('#user_account_min_units_managed').value = val;
  }

  updateListingSlider(sliderWrapper) {
    const {slider, valueInput, val, percent} = this.getSliderData(sliderWrapper);
    this.updateSlideBackground(slider, percent);

    valueInput.value = val;

    sliderWrapper.closest('.js-plans-description').querySelectorAll('.js-card').forEach((card) => {
      const plan = card.dataset.plan;
      const priceData = SignupSliderUtils.calculateListingPrice(plan, val, this.#listingsBasedPricingRules);
      if (!priceData) {
        LayoutUtils.hide(card);
        return;
      }

      LayoutUtils.show(card);
      const usdTotalCost = SignupSliderUtils.formatUSD(priceData.totalMonthly);

      card.querySelector('.js-value').innerText = val;
      card.querySelector('.js-listing-based-listings-included').innerText = priceData.included;
      card.querySelector('.js-listing-based-listings-additional-price').innerText = SignupSliderUtils.formatUSD(priceData.addonsMonthly);
      card.querySelector('.js-total-price').innerText = usdTotalCost;
      card.querySelector('.js-additional-amount').innerText = priceData.extraUnits;
      card.querySelector('.js-listing-based-price').innerText = SignupSliderUtils.formatUSD(priceData.baseMonthly);

      const additionalWrapper = card.querySelector('.js-additional-info-wrapper');
      if (priceData.extraUnits === 0) {
        LayoutUtils.hide(additionalWrapper);
      } else {
        LayoutUtils.show(additionalWrapper);
      }
    });
  }

  fetchListingBasedPricingRules(listingBasedPlansData) {
    this.#listingsBasedPricingRules = SignupSliderUtils.buildListingPricingRules(listingBasedPlansData);
  }

  init() {
    const listingBasedPlansData = JSON.parse(document.querySelector('.js-signup-form-wrapper').dataset.listingPlans);
    this.fetchListingBasedPricingRules(listingBasedPlansData);

    document.querySelectorAll('.js-unit-slider-wrapper').forEach((s) => {
      s.querySelector('.js-signup-slider-input').addEventListener('input', () => { this.updateUnitSlider(s); });
      s.querySelector('.js-signup-slider-value').addEventListener('change', (e) => {
        s.querySelector('.js-signup-slider-input').value = e.target.value;
        this.updateUnitSlider(s);
      });
      this.updateUnitSlider(s);
    });

    document.querySelectorAll('.js-listing-slider-wrapper').forEach((s) => {
      s.querySelector('.js-signup-slider-input').addEventListener('input', () => { this.updateListingSlider(s); });
      s.querySelector('.js-signup-slider-value').addEventListener('change', (e) => {
        s.querySelector('.js-signup-slider-input').value = e.target.value;
        this.updateListingSlider(s);
      });
      this.updateListingSlider(s);
    });

    document.addEventListener('sm-auth-sliders:update-unit', () => {
      document.querySelectorAll('.js-unit-slider-wrapper').forEach((s) => this.updateUnitSlider(s));
    });

    const listingsPlansSelect = document.querySelector('.js-listing-based-plans-select');
    listingsPlansSelect.addEventListener('change', (e) => {
      const plan = listingBasedPlansData.find(el => {return el.id === +e.target.value;});
      document.querySelectorAll('.js-listing-slider-wrapper').forEach((s) => {
        const sliderValue = s.querySelector('.js-signup-slider-value');
        sliderValue.value = plan.listings_included;
        sliderValue.dispatchEvent(new Event('change'));
      });
    });
  }
}

export default Sliders;
